module.exports = __webpack_public_path__ + "static/Rage Cage_x264-75272521c05762280014a344a416d769.mp4";